import { any, lt, gt, map, pipe, split, tap } from 'ramda';

// [Number] -> void | Error
const validatePositiveAndNegative = (numbers) => {
    const hasPositive = any(lt(0), numbers);
    const hasNegative = any(gt(0), numbers);
    if (!hasPositive || !hasNegative) {
        throw new Error(
            `Values must contain at least one positive and one negative number`,
        );
    }
};

// String -> Number | Error
const parseAndValidateValue = (value) => {
    const number = Number(value);
    if (Number.isNaN(number)) {
        throw new Error(`Invalid number: ${value}`);
    }
    return number;
};

// Used for IRR and NPV commands to validate that input includes at least one positive and one negative number
// String -> [Number] | Error
export const parseAndValidateCashflowSeries = pipe(
    split(','),
    map((value) => parseAndValidateValue(value)),
    tap((numbers) => validatePositiveAndNegative(numbers)),
);
